/**
 * Endereços decididos no handoff:
 *  - Tela da cabine:   {codigo}.azanas.tech   (RN-107)  → rota interna /cabine/:subdominio
 *  - Página do médico: {subdominio}.azanas.me (RN-87)   → rota interna /m/:subdominio
 * Em desenvolvimento: rr00100far01.cabine.localhost:3000 e drana.medico.localhost:3000 (ou acessar as rotas direto).
 */
const RESERVED = new Set(['www', 'app', 'painel', 'api', 'admin', 'static']);

export type HostContext = { kind: 'cabin'; subdomain: string } | { kind: 'doctor-page'; subdomain: string } | { kind: 'default' };

export function resolveHost(hostname = window.location.hostname): HostContext {
  const h = hostname.toLowerCase();
  let m = h.match(/^([a-z0-9]+)\.azanas\.tech$/) ?? h.match(/^([a-z0-9]+)\.cabine\.localhost$/);
  if (m && !RESERVED.has(m[1]!)) return { kind: 'cabin', subdomain: m[1]! };
  m = h.match(/^([a-z0-9-]+)\.azanas\.me$/) ?? h.match(/^([a-z0-9-]+)\.medico\.localhost$/);
  if (m && !RESERVED.has(m[1]!)) return { kind: 'doctor-page', subdomain: m[1]! };
  return { kind: 'default' };
}

/** Link público da página do médico (produção: subdomínio; dev: rota). */
export function doctorPageUrl(subdomain: string) {
  return window.location.hostname.endsWith('azanas.tech') || window.location.hostname.endsWith('azanas.me')
    ? `https://${subdomain}.azanas.me`
    : `${window.location.origin}/m/${subdomain}`;
}

export function cabinUrl(subdomain: string) {
  return window.location.hostname.endsWith('azanas.tech') ? `https://${subdomain}.azanas.tech` : `${window.location.origin}/cabine/${subdomain}`;
}
